import { useMediaQuery } from 'usehooks-ts'

function useIsMobile (): boolean {
  return useMediaQuery('(max-width: 767px)')
}

export default useIsMobile
